
import axios from 'axios';
import {detect} from 'detect-browser';
import { v4 as uuidv4 } from 'uuid';

const browser = detect();

export const myUUID = uuidv4();

export const axiosInstance = axios.create();

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'BrowserId': myUUID
};

if (browser.name === 'ie') {
  headers.expires = -1;
  headers['Cache-Control'] = 'no-cache';
}
export function getData(path, method, onErr) {
  apiFetch(path, 'GET', '',
    (response) => {
      if (method instanceof Array) {
        method.forEach(singleMethod => singleMethod(response));
      } else {
        method(response);
      }
    },
    (error) => {
      onErr(error);
    });
}

export default function apiFetch(URLPath, method, body, callback, errCallback, passedHeaders) {
  const request = {
    method,
    url: URLPath,
    headers: passedHeaders || headers,
    data: method !== 'GET' ? body : undefined
  };

  axiosRequest(request, URLPath, callback, errCallback);
}

export function getBinary(URLPath, method, body, callback, errCallback) {
  const request = {
    method,
    url: URLPath,
    headers,
    responseType: 'blob',
    data: method !== 'GET' ? body : undefined
  };

  axiosRequest(request, URLPath, callback, errCallback);
}

function axiosRequest(request, URL, callback, errCallback) {
  axiosInstance.request(request)
  .then(response => {
    if (response.status === 204) {
      callback();
      return;
    }

    return response.data;
  })
  .then((results) => {
    // if response.ok is false, then the error callback is called but it still comes here
    if (results) {
      callback(results);
    }
  })
  .catch((error) => {
    console.log(error);
    console.log(URL);
    errCallback(error);
  });
}
